module.exports = __webpack_public_path__ + "media/משמש.0a024295.mp3";